// This is a polyfill for IE to prevent the Leaflet map from showing up with no pins
if (typeof Object.assign != 'function') {
    Object.assign = function(target) {
        'use strict';
        if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
        }
        return target;
    };
}

import $ from 'jquery';
import Vue from "vue";
import {LMap, LTileLayer, LMarker, LIcon, LPopup} from 'vue2-leaflet';
import {DropdownPlugin, ListGroupPlugin} from 'bootstrap-vue';
import Vue2TouchEvents from 'vue2-touch-events'

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
Vue.component('l-popup', LPopup);
Vue.use(Vue2TouchEvents);

Vue.use(DropdownPlugin);
Vue.use(ListGroupPlugin);

window.$ = window.jQuery = $;
window.Vue = Vue;

// comment

// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/carousel';
